import { Star } from "lucide-react";

export const Stars = ({ value, onChange, size = 16, testId }) => (
  <div className="flex gap-1" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => {
      const icon = <Star size={size} className={n <= value ? "fill-[#D4AF37] text-[#D4AF37]" : "text-[#D4AF37]/40"} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n} star${n > 1 ? "s" : ""}`} className="transition-transform duration-200 hover:scale-110" data-testid={`${testId}-${n}`}>{icon}</button>
      ) : <span key={n}>{icon}</span>;
    })}
  </div>
);
